import React from 'react'
import styled from 'styled-components'

import Image from '../../atoms/Image'

export type ECUrlType = 'akachan' | 'amazon' | 'landing' | 'official' | 'rakuten' | 'toysrus' | 'wowma' | 'yahoo'

const ecSiteNames: { [key in ECUrlType]: string } = {
  akachan: 'アカチャンホンポ',
  amazon: 'Amazon',
  landing: '公式サイト',
  official: '公式ショッピングサイト',
  rakuten: '楽天市場',
  toysrus: 'トイザらス',
  wowma: 'au Wowma!',
  yahoo: 'Yahoo!ショッピング',
}

const Container = styled.div`
  position: relative;
  width: 100%;
`

const ECSiteLogo = styled(Image)<{ width: string }>`
  margin: 0 auto;
  width: ${({ width }) => width};
`

const BasicText = styled.span`
  color: ${({ theme }) => theme.palette.font.link};
  font-size: 14px;
  font-weight: 600;
`

const Icon = styled(Image)`
  object-fit: contain;
  margin: auto 0;
  position: absolute !important;
  top: 0;
  right: 0;
  bottom: 0;
  width: 14px;
  height: 14px;
`

function Text({ type }: Props) {
  switch (type) {
    case 'akachan':
      return <ECSiteLogo alt={ecSiteNames[type]} filename="logo-akachan.png" width="160px" />
    case 'amazon':
      return <ECSiteLogo alt={ecSiteNames[type]} filename="logo-amazon.png" width="91px" />
    case 'landing':
      return <BasicText>公式サイト</BasicText>
    case 'official':
      return <BasicText>公式EC</BasicText>
    case 'rakuten':
      return <ECSiteLogo alt={ecSiteNames[type]} filename="logo-rakuten.png" width="85px" />
    case 'toysrus':
      return <ECSiteLogo alt={ecSiteNames[type]} filename="logo-toysrus.png" width="94px" />
    case 'wowma':
      return <ECSiteLogo alt={ecSiteNames[type]} filename="logo-wowma.png" width="128px" />
    case 'yahoo':
      return <ECSiteLogo alt={ecSiteNames[type]} filename="logo-yahoo-shopping.png" width="140px" />
    default:
      throw new TypeError(`"type" is not ECUrlType: ${type}`)
  }
}

type Props = {
  type: ECUrlType
}

export default function ButtonText({ type }: Props) {
  return (
    <Container>
      <Text type={type} />
      <Icon alt={`${ecSiteNames[type]}でみる`} filename="icon-launch-pink.png" />
    </Container>
  )
}
